import React, { useContext } from 'react';
import pt from 'prop-types';
import Text from '../text';
import { combine } from '../../../helpers/styles';
import * as styles from './dropdown.module.scss';
import { MicrocopyContext } from '../../../context/microcopy.context';
import { getCopy } from '../../../helpers/copy';

const Dropdown = ({
  name,
  defaultValue,
  className,
  onSelect,
  options,
  withoutLabel,
}) => {
  const microcopy = useContext(MicrocopyContext);
  return (
    <div
      className={combine(
        className,
        styles.dropdown,
        withoutLabel && styles.withoutLabel
      )}
    >
      {!withoutLabel && (
        <label htmlFor={name}>
          <Text as="span" type="copy2">
            {getCopy('label.pleaseSelect', microcopy)}
          </Text>
        </label>
      )}
      <select
        id={name}
        name={name}
        className={styles.select}
        defaultValue={defaultValue}
        onChange={onSelect}
      >
        {options.map((item, index) => (
          <option key={index} value={item.value} disabled={item.disabled}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

Dropdown.propTypes = {
  name: pt.string,
  defaultValue: pt.string,
  className: pt.string,
  onSelect: pt.func,
  options: pt.arrayOf(
    pt.shape({
      label: pt.string,
      value: pt.string,
    })
  ),
  withoutLabel: pt.bool,
};
Dropdown.defaultProps = {
  className: '',
  defaultValue: '',
  options: [],
};

export default Dropdown;
